import React, { createContext, useState, useContext } from 'react';
export var IngredientsStyleOption;
(function (IngredientsStyleOption) {
    IngredientsStyleOption["JOYFULLY_BOLD"] = "joyfully-bold";
})(IngredientsStyleOption || (IngredientsStyleOption = {}));
var initialContext = {
    options: undefined,
};
export var IngredientsStyleOptionsContext = createContext(initialContext);
var getOptions = function (option, enabled, contextOptions) {
    var stateOptions = contextOptions;
    var optionInState = stateOptions === null || stateOptions === void 0 ? void 0 : stateOptions.includes(option);
    var options = stateOptions === null || stateOptions === void 0 ? void 0 : stateOptions.slice();
    if (optionInState && !enabled) {
        options = stateOptions === null || stateOptions === void 0 ? void 0 : stateOptions.filter(function (opt) { return opt !== option; });
    }
    if (options !== undefined && !optionInState && enabled) {
        options.push(option);
    }
    return options;
};
var setOptionState = function (_a) {
    var setter = _a.setter, contextOptions = _a.contextOptions, option = _a.option, enabled = _a.enabled;
    var options = getOptions(option, enabled, contextOptions);
    setter(options);
};
export var IngredientsStyleOptionsProvider = function (_a) {
    var children = _a.children, options = _a.options;
    var _b = useState(options), contextOptions = _b[0], setContextOptions = _b[1];
    return (React.createElement(IngredientsStyleOptionsContext.Provider, { value: {
            options: contextOptions,
            setOption: function (option, enabled) {
                setOptionState({ setter: setContextOptions, contextOptions: contextOptions, option: option, enabled: enabled });
            },
        } }, children));
};
export var useIngredientsStyleOptionsContext = function () {
    var context = useContext(IngredientsStyleOptionsContext);
    return context;
};
export var isIngredientsStyleOption = function (option, optionContext) { var _a; return (_a = optionContext.options) === null || _a === void 0 ? void 0 : _a.includes(option); };
//# sourceMappingURL=IngredientsStyleOptionsProvider.js.map